let pdfSrc = [
  "https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pdf/FY200.pdf",
  "https://gzyit-yyx.oss-cn-beijing.aliyuncs.com/pdf/FY070.pdf"
]

export default pdfSrc



// WEBPACK FOOTER //
// ./src/assets/conf/pdfSrc.js